import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ElementLocale from 'element-ui/lib/locale'
// import enLocale from 'element-ui/lib/locale/lang/en'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import langZh from "@/i18n/langs/zh.js"
import langEN from "@/i18n/langs/en.js"
// Vue.use(ElementUI, { locale })
Vue.use(VueI18n)

const i18n = new VueI18n({
    // locale = sessionStorage.getItem("usermsg"),

    locale: JSON.parse(sessionStorage.getItem("usermsg")) ? JSON.parse(sessionStorage.getItem("usermsg")).lang == 'en_US' ? 'en_US' : 'zh_CN' : 'zh_CN',
    // locale: JSON.parse(sessionStorage.getItem("usermsg")) ? JSON.parse(sessionStorage.getItem("usermsg")).lang == 'en_US' ? 'en_US' : 'zh_CN' : 'zh_CN',



    //默认选择语言
    // locale: 'zh_CN',
    messages: {
        // 'zh_CN': require('@/i18n/langs/zh.js'),
        // 'en_US': require('@/i18n/langs/en.js')
        // 'zh_CN': {...langZh, ...zhLocale },
        // 'en_US': {...langEN, ...enLocale },
        'zh_CN': {...langZh },
        'en_US': {...langEN }
    },

    silentTranslationWarn: true,
})

// window.location.reload()
ElementLocale.i18n((key, value) => i18n.t(key, value))
    // console.log(i18n.locale)
export default i18n